(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initStickyHeader(wrapperEl) {
    var header = document.querySelector('.section-header');
    if (!header) return;

    var headerIsAlwaysSticky = wrapperEl.getAttribute('data-sticky-type') === 'always' || wrapperEl.getAttribute('data-sticky-type') === 'reduce-logo-size';
    var headerBounds = {};
    var currentScrollTop = 0;
    var preventReveal = false;
    var predictiveSearch = wrapperEl.querySelector('predictive-search');
    var isScrollingTimeout;

    function setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }

    function createObserver() {
      var observer = new IntersectionObserver(function (entries, observer) {
        headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(header);
    }

    function closeMenuDisclosure() {
      var disclosures = header.querySelectorAll('header-menu');
      disclosures.forEach(function (disclosure) {
        disclosure.close();
      });
    }

    function closeSearchModal() {
      var searchModal = header.querySelector('details-modal');
      if (searchModal) searchModal.close(false);
    }

    function hide() {
      if (headerIsAlwaysSticky) return;
      header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      closeMenuDisclosure();
      closeSearchModal();
    }

    function reveal() {
      if (headerIsAlwaysSticky) return;
      header.classList.add('shopify-section-header-sticky', 'animate');
      header.classList.remove('shopify-section-header-hidden');
    }

    function reset() {
      if (headerIsAlwaysSticky) return;
      header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    function onScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (predictiveSearch && predictiveSearch.isOpen) return;

      if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom) {
        header.classList.add('scrolled-past-header');
        requestAnimationFrame(hide);
      } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom) {
        header.classList.add('scrolled-past-header');
        if (!preventReveal) {
          requestAnimationFrame(reveal);
        } else {
          window.clearTimeout(isScrollingTimeout);
          isScrollingTimeout = setTimeout(function () {
            preventReveal = false;
          }, 66);
          requestAnimationFrame(hide);
        }
      } else if (scrollTop <= headerBounds.top) {
        header.classList.remove('scrolled-past-header');
        requestAnimationFrame(reset);
      }

      currentScrollTop = scrollTop;
    }

    setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', setHeaderHeight);

    if (headerIsAlwaysSticky) {
      header.classList.add('shopify-section-header-sticky');
    }

    wrapperEl.addEventListener('preventHeaderReveal', function () {
      preventReveal = true;
    });
    window.addEventListener('scroll', onScroll, false);

    createObserver();
  }

  document.querySelectorAll('.header-wrapper[data-sticky-type]').forEach(initStickyHeader);

  } catch(e) { console.error(e); }
})();
})();
